<template>
  <q-tooltip>
    Must switch to English first
  </q-tooltip>
</template>

<script>
export default {
  name: 'EnglishRequiredTooltip'
}
</script>
